import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "@/constants/nav";

export function SidebarNav() {
  return (
    <nav className="flex flex-col gap-1 px-3 overflow-y-auto" data-testid="sidebar-nav">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          data-testid={item.testId}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 ${
              isActive ? "bg-[var(--oim-surface-softer)]" : "hover:bg-[var(--oim-hover)]"
            }`
          }
          style={({ isActive }) => ({ color: isActive ? "var(--oim-text)" : "var(--oim-text-muted)" })}
        >
          <item.icon className="w-4 h-4" strokeWidth={1.75} />
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
